module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1064.d61ca6b3.png";